import { buriedPoint } from '@pro/common/bury-point';

const buryPoint = {
  bottomIconLink(type) {
    const op = {
      1: 'Device compatibility list',
      2: 'user manual',
      3: 'dateSheet',
      4: "what's new"
    };

    buriedPoint('event', {
      eventCategory: 'bottomIconLink',
      action: 'bottomIconLink',
      eventLabel: op[type]
    });
  },
  bottomWordLink(type) {
    const op = {
      1: 'where to buy',
      2: 'HikVision website',
      3: 'Technology partner portal',
      4: 'eLearning',
      5: 'Privacy policy',
      6: 'Terms of use',
      7: 'B2B2 Terms and Condition',
      8: 'FAQ'
    };

    buriedPoint('event', {
      eventCategory: 'bottomWordLink',
      action: 'bottomWordLink',
      eventLabel: op[type]
    });
  }
};

export default buryPoint;
